import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import { getUserRole, checkPermission } from "utils/auth";
import routes from "../../routes";

const Sidebar = ({ open, onClose }) => {
    const userRole = getUserRole();

    const authorizedRoutes = routes.filter(
        (route) => !route.requiredRole || checkPermission(route.requiredRole, userRole)
    );

    return (
        <div
            className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white ${open ? "translate-x-0" : "-translate-x-full"
                } w-64`}
        >
            <span className="absolute top-4 right-4 block cursor-pointer xl:hidden" onClick={onClose}>
                <HiX size={24} />
            </span>

            <div className="mx-auto mt-10 flex items-center">
                <div className="mt-1 ml-1 h-2.5 font-poppins text-[22px] font-bold uppercase text-[#57A863] dark:text-white">
                    AENAT ADMIN
                </div>
            </div>

            <div className="mt-8 mb-7 h-px bg-gray-300 dark:bg-white/30" />

            <ul className="mb-auto pt-1">
                <Links routes={authorizedRoutes} />
            </ul>
        </div>
    );
};

export default Sidebar;